/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Formik, FormikHelpers } from 'formik';

import { useHistory } from 'react-router-dom';
import {
  LuBuilding2,
  LuCalendarRange,
  LuFileSearch,
  LuLandmark,
  LuScale,
  LuUsers,
} from 'react-icons/lu';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { SelectButton } from 'primereact/selectbutton';

import api from '../../../services/api';

import { useToast } from '../../../hooks/toast';

import {
  DateFilter,
  DateMode,
  Field,
  FilterStyles,
  Section,
} from '../../../components/FilterKit';

interface SearchData {
  proc_reg: string;
  proc_num_pasta: string;
  proc_reg_outros : string;
  // proc_cod_acao: number;
  proc_cod_orgao: number;
  proc_cod_natureza: number;
  proc_orgao_cidade: string;
  proc_orgao_uf: string;
  proc_autor: string;
  proc_reu: string;
  proc_cod_cliente: number;
  grupo_economico_id: number;
  proc_cod_adv_resp: number;
  proc_cod_ass_resp: number;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
  proc_data_ingresso_inicio: Date;
  proc_data_ingresso_final: Date;
  proc_em_acordo: string;
  updatedin: number;
  nochanges: number;
  formValuesChanged: boolean;
}

interface IBusinessGroupProperties {
  id: number | null;
  parent_company_id: number;
  children_companies: string;
  report_columns: string;
}

interface ICustomerProperties {
  cliente_id: number | null;
  cliente_nome: string;
}

const SearchLawsuitSummary:React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const initialValues: SearchData = {
    proc_reg: '',
    proc_num_pasta: '',
    proc_reg_outros: '',
    // proc_cod_acao: 0,
    proc_cod_orgao: 0,
    proc_cod_natureza: 0,
    proc_orgao_cidade: '',
    proc_orgao_uf: '',
    proc_autor: '',
    proc_reu: '',
    proc_cod_cliente: 0,
    grupo_economico_id: 0,
    proc_cod_adv_resp: 0,
    proc_cod_ass_resp: 0,
    proc_data_ajuiz_inicio: new Date(),
    proc_data_ajuiz_final: new Date(),
    proc_data_ingresso_inicio: new Date(),
    proc_data_ingresso_final: new Date(),
    proc_em_acordo: '4',
    updatedin: 0,
    nochanges: 0,
    formValuesChanged: false,
  };

  const [lawsuitRegistrationNumber, setLawsuitRegistrationNumber] = useState('');
  const [lawsuitFolderNumber, setLawsuitFolderNumber] = useState('');
  const [otherLawsuitNumbers, setOtherLawsuitNumbers] = useState('');
  const [natureSuitsOptions, setNatureSuitsOptions] = useState([{}]);
  const [suitTypesOptions, setSuitTypesOptions] = useState([{}]);
  const [author, setAuthor] = useState('');
  const [defendant, setDefendant] = useState('');
  const [lawsuitId, setLawsuitId] = useState('');
  const [natureId, setNatureId] = useState('');
  const [judgingBodyCityId, setJudgingBodyCityId] = useState('');
  const [judgingBodyStateId, setJudgingBodyStateId] = useState('');
  const [customerId, setCustomerId] = useState('0');
  const [businessGroupId, setBusinessGroupId] = useState('0');
  const [attorneyInChargeId, setAttorneyInChargeId] = useState('');
  const [assistantInChargeId, setAssistantInChargeId] = useState('');
  const [lawsuitStatus, setLawsuitStatus] = useState('4');

  const [updatedInDay, setUpdatedInDay] = useState(0);
  const [noChangesDay, setNoChangesDay] = useState(0);

  const [
    initialRegistrationDate, setInitialRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [
    finalRegistrationDate, setFinalRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [
    initialEntranceDate, setInitialEntranceDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [finalEntranceDate, setFinalEntranceDate] = useState<string | Date | Date[] | null>(null);

  const [attorneysOptions, setAttorneysOptions] = useState([{}]);
  const [assistantsOptions, setAssistantsOptions] = useState([{}]);
  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [businessGroupOptions, setBusinessGroupOptions] = useState([{}]);
  const [dateFilterType, setDateFilterType] = useState('data');
  const [registeredFilterType, setRegisteredFilterType] = useState('data');

  const [customers, setCustomers] = useState<ICustomerProperties[]>([]);

  const handleClear = (resetForm: () => void) => {
    setLawsuitRegistrationNumber('');
    setLawsuitFolderNumber('');
    setOtherLawsuitNumbers('');
    setAuthor('');
    setDefendant('');
    setLawsuitId('');
    setNatureId('');
    setJudgingBodyCityId('');
    setJudgingBodyStateId('');
    setCustomerId('0');
    setBusinessGroupId('0');
    setAttorneyInChargeId('');
    setAssistantInChargeId('');
    setLawsuitStatus('4');
    setUpdatedInDay(0);
    setNoChangesDay(0);
    setInitialRegistrationDate(null);
    setFinalRegistrationDate(null);
    setInitialEntranceDate(null);
    setFinalEntranceDate(null);
    setDateFilterType('data');
    setRegisteredFilterType('data');
    resetForm();
  };

  const validationSchema = null;

  const lawsuitStatusOptions = [
    { name: 'ativos', value: '0', style: 'font-size: small;' },
    { name: 'em acordo', value: '1', style: 'font-size: small;' },
    { name: 'arquivados', value: '2', style: 'font-size: small;' },
    { name: 'ativos+em acordo', value: '4', style: 'font-size: small;' },
    { name: 'todos', value: '5', style: 'font-size: small;' },
  ];

  useEffect(() => {
    (async () => {
      await api.get('lawsuits/naturesuits/show/all').then((response) => {
        response.data.map((natureSuit: { natureza_id: number, natureza_descricao:string}) => (
          natureSuitsOptions.push({
            name: natureSuit.natureza_descricao,
            value: natureSuit.natureza_id,
          })
        ));
      });
      natureSuitsOptions.splice(0, 1);
      setNatureSuitsOptions(natureSuitsOptions);
    })();
  }, [natureSuitsOptions]);

  useEffect(() => {
    (async () => {
      await api.get('lawsuits/suittypes/show/all').then((response) => {
        response.data.map((natureSuit: { acao_id: number, acao_descricao:string}) => (
          suitTypesOptions.push({
            name: natureSuit.acao_descricao,
            value: natureSuit.acao_id,
          })
        ));
      });
      suitTypesOptions.splice(0, 1);
      setSuitTypesOptions(suitTypesOptions);
    })();
  }, [suitTypesOptions]);

  const brazilianStatesOptions = [
    { name: 'AC', value: 'AC' },
    { name: 'AL', value: 'AL' },
    { name: 'AM', value: 'AM' },
    { name: 'AP', value: 'AP' },
    { name: 'BA', value: 'BA' },
    { name: 'CE', value: 'CE' },
    { name: 'DF', value: 'DF' },
    { name: 'ES', value: 'ES' },
    { name: 'GO', value: 'GO' },
    { name: 'MA', value: 'MA' },
    { name: 'MG', value: 'MG' },
    { name: 'MS', value: 'MS' },
    { name: 'MT', value: 'MT' },
    { name: 'PA', value: 'PA' },
    { name: 'PB', value: 'PB' },
    { name: 'PE', value: 'PE' },
    { name: 'PI', value: 'PI' },
    { name: 'PR', value: 'PR' },
    { name: 'RJ', value: 'RJ' },
    { name: 'RN', value: 'RN' },
    { name: 'RO', value: 'RO' },
    { name: 'RR', value: 'RR' },
    { name: 'RS', value: 'RS' },
    { name: 'SC', value: 'SC' },
    { name: 'SE', value: 'SE' },
    { name: 'SP', value: 'SP' },
    { name: 'TO', value: 'TO' },
  ];

  useEffect(() => {
    (async () => {
      await api.get('management/attorneys/show/all').then((response) => {
        response.data.map((attorney:
        {
          advogado_id: number,
          advogado_nome:string
        }) => (
          attorneysOptions.push({
            name: attorney.advogado_nome,
            value: attorney.advogado_id,
          })
        ));
      });
      attorneysOptions.splice(0, 1);
      setAttorneysOptions(attorneysOptions);
    })();
  }, [attorneysOptions]);

  useEffect(() => {
    (async () => {
      await api.get('management/assistants/show/all').then((response) => {
        response.data.map((assistant:
        {
          administrador_id: number,
          administrador_nome:string
        }) => (
          assistantsOptions.push({
            name: assistant.administrador_nome,
            value: assistant.administrador_id,
          })
        ));
      });
      assistantsOptions.splice(0, 1);
      setAssistantsOptions(assistantsOptions);
    })();
  }, [assistantsOptions]);

  useEffect(() => {
    (async () => {
      await api.get('customers/show/all').then((response) => {
        setCustomers(response.data);
        response.data.map((customer:
        {
          cliente_id: number,
          cliente_nome:string
        }) => (
          customersOptions.push({
            name: customer.cliente_nome,
            value: customer.cliente_id,
          })
        ));
      });
      customersOptions.splice(0, 1);
      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  useEffect(() => {
    (async () => {
      await api.get('businessGroups/show/all').then((response) => {
        response.data.forEach((item: IBusinessGroupProperties) => {
          const filteredCustomer = customers.filter((stored) => (
            stored.cliente_id === Number(item.parent_company_id)
          ), []);

          businessGroupOptions.push({
            name: filteredCustomer[0]?.cliente_nome,
            value: item.id,
          });
        });
      });
      businessGroupOptions.splice(0, 1);
      setBusinessGroupOptions(businessGroupOptions);
    })();
  }, [businessGroupOptions, customers]);

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>,
  ) => {
    try {
      const searchFormData = {
        proc_reg: lawsuitRegistrationNumber,
        proc_num_pasta: lawsuitFolderNumber,
        proc_reg_outros: otherLawsuitNumbers,
        proc_cod_acao: lawsuitId,
        // proc_cod_orgao: judgingBodyId,
        proc_cod_natureza: natureId,
        proc_orgao_cidade: judgingBodyCityId,
        proc_orgao_uf: judgingBodyStateId,
        proc_autor: author,
        proc_reu: defendant,
        proc_cod_cliente: customerId,
        grupo_economico_id: businessGroupId,
        proc_cod_adv_resp: attorneyInChargeId,
        proc_cod_ass_resp: assistantInChargeId,
        dateFilterType,
        registeredFilterType,
        proc_data_ajuiz_inicio: initialRegistrationDate,
        proc_data_ajuiz_final: finalRegistrationDate,
        proc_data_ingresso_inicio: initialEntranceDate,
        proc_data_ingresso_final: finalEntranceDate,
        proc_em_acordo: lawsuitStatus,
        updatedin: updatedInDay,
        nochanges: noChangesDay,
        formValuesChanged: false,
      };

      history.push({
        pathname: '/report/lawsuit/summary/customizable',
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ocorreu um problema',
        description:
              'Tente repetir a pesquisa ou contate o administrador.',
      });
    }
  };
  // TODO: define set form changed
  return (
    <FilterStyles>
      <div className="card search-card">
        <header className="search-title">
          <h3>Relatório CUSTOMIZÁVEL de Informações Processuais - Modelo I</h3>
          <span className="search-hint">Preencha só o que precisar.</span>
        </header>

        <Formik
          onSubmit={handleOnSubmit}
          validationSchema={validationSchema}
          enableReinitialize
          initialValues={initialValues}
        >
          {({
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="search-grid">
                <div className="search-col">
                  <Section icon={<LuFileSearch />} title="Identificação">
                    <div className="row r3">
                    <Field id="proc_reg" label="Nº do processo">
                      <InputText
                        id="proc_reg"
                        name="proc_reg"
                        className="inputfield w-full"
                        onChange={(e) => {
                          setLawsuitRegistrationNumber(e.target.value);
                          handleChange(e);
                        }}
                        value={lawsuitRegistrationNumber}
                      />
                    </Field>
                    <Field id="proc_num_pasta" label="Pasta nº">
                      <InputText
                        id="proc_num_pasta"
                        name="proc_num_pasta"
                        className="inputfield w-full"
                        onChange={(e) => setLawsuitFolderNumber(e.target.value)}
                        onBlur={handleBlur}
                        value={lawsuitFolderNumber}
                      />
                    </Field>
                    <Field id="proc_reg_outros" label="Outros nrs. do processo">
                      <InputText
                        id="proc_reg_outros"
                        name="proc_reg_outros"
                        className="inputfield w-full"
                        onChange={(e) => setOtherLawsuitNumbers(e.target.value)}
                        onBlur={handleBlur}
                        value={otherLawsuitNumbers}
                      />
                    </Field>
                    </div>
                  </Section>

                  <Section icon={<LuScale />} title="Partes">
                    <div className="row r2">
                    <Field id="proc_autor" label="Autor">
                      <InputText
                        id="proc_autor"
                        name="proc_autor"
                        className="inputfield w-full"
                        onChange={(e) => setAuthor(e.target.value)}
                        value={author}
                        autoFocus
                      />
                    </Field>
                    <Field id="proc_reu" label="Réu">
                      <InputText
                        id="proc_reu"
                        name="proc_reu"
                        className="inputfield w-full"
                        onChange={(e) => setDefendant(e.target.value)}
                        value={defendant}
                      />
                    </Field>
                    </div>
                  </Section>

                  <Section icon={<LuUsers />} title="Responsáveis">
                    <div className="row r2">
                    <Field id="proc_cliente" label="Cliente">
                      <Dropdown
                        inputId="proc_cliente"
                        name="proc_cliente"
                        options={customersOptions}
                        onChange={(e) => setCustomerId(e.target.value)}
                        value={customerId}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="grupo_economico_id" label="Grupo econômico">
                      <Dropdown
                        inputId="grupo_economico_id"
                        name="grupo_economico_id"
                        options={businessGroupOptions}
                        onChange={(e) => setBusinessGroupId(e.target.value)}
                        value={businessGroupId}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="proc_cod_adv_resp" label="Adv. Responsável">
                      <Dropdown
                        inputId="proc_cod_adv_resp"
                        name="proc_cod_adv_resp"
                        options={attorneysOptions}
                        onChange={(e) => setAttorneyInChargeId(e.target.value)}
                        value={attorneyInChargeId}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="proc_cod_ass_resp" label="Assistente">
                      <Dropdown
                        inputId="proc_cod_ass_resp"
                        name="proc_cod_ass_resp"
                        options={assistantsOptions}
                        onChange={(e) => setAssistantInChargeId(e.target.value)}
                        value={assistantInChargeId}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    </div>
                  </Section>

                  <Section icon={<LuLandmark />} title="Classificação e local">
                    <div className="row r4">
                    <Field id="proc_cod_acao" label="Tipo de ação">
                      <Dropdown
                        inputId="proc_cod_acao"
                        name="proc_cod_acao"
                        options={suitTypesOptions}
                        onChange={(e) => setLawsuitId(e.target.value)}
                        value={lawsuitId}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Todas"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="proc_cod_natureza" label="Natureza do processo">
                      <Dropdown
                        inputId="proc_cod_natureza"
                        name="proc_cod_natureza"
                        options={natureSuitsOptions}
                        onChange={(e) => setNatureId(e.target.value)}
                        value={natureId}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Todas"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    <Field id="proc_orgao_cidade" label="Cidade">
                      <InputText
                        id="proc_orgao_cidade"
                        name="proc_orgao_cidade"
                        className="inputfield w-full"
                        onChange={(e) => setJudgingBodyCityId(e.target.value)}
                        value={judgingBodyCityId}
                      />
                    </Field>
                    <Field id="proc_orgao_uf" label="Estado">
                      <Dropdown
                        inputId="proc_orgao_uf"
                        name="proc_orgao_uf"
                        options={brazilianStatesOptions}
                        onChange={(e) => setJudgingBodyStateId(e.target.value)}
                        value={judgingBodyStateId}
                        className="inputfield w-full"
                        optionLabel="name"
                        optionValue="value"
                        filter
                        resetFilterOnHide
                        filterBy="name"
                        placeholder="Selecione uma opção"
                        emptyFilterMessage="Nenhum registro encontrado"
                      />
                    </Field>
                    </div>
                  </Section>
                </div>

                <div className="search-col">
                  <Section icon={<LuCalendarRange />} title="Datas">
                    <DateFilter
                      id="ajuizamento"
                      label="Data de ajuizamento"
                      withMode
                      value={{
                        mode: dateFilterType as DateMode,
                        start: initialRegistrationDate as Date | null,
                        end: finalRegistrationDate as Date | null,
                      }}
                      onChange={(next) => {
                        setDateFilterType(next.mode);
                        setInitialRegistrationDate(next.start);
                        setFinalRegistrationDate(next.end);
                      }}
                    />
                    <DateFilter
                      id="ingresso"
                      label="Ingresso no escritório"
                      withMode
                      value={{
                        mode: registeredFilterType as DateMode,
                        start: initialEntranceDate as Date | null,
                        end: finalEntranceDate as Date | null,
                      }}
                      onChange={(next) => {
                        setRegisteredFilterType(next.mode);
                        setInitialEntranceDate(next.start);
                        setFinalEntranceDate(next.end);
                      }}
                    />
                  </Section>

                  <Section icon={<LuBuilding2 />} title="Situação do processo">
                    <Field id="proc_em_acordo" label="Incluir processos">
                      <SelectButton
                        className="status-buttons"
                        id="proc_em_acordo"
                        value={lawsuitStatus}
                        options={lawsuitStatusOptions}
                        optionLabel="name"
                        onChange={(e) => setLawsuitStatus(e.value)}
                      />
                    </Field>
                    <div className="idle-filters">
                      <label htmlFor="updatedin">
                        Processos sem atualização nos últimos
                        <InputNumber
                          inputId="updatedin"
                          name="updatedin"
                          placeholder="X"
                          value={updatedInDay}
                          onValueChange={(e) => setUpdatedInDay(Number(e.value))}
                          min={0}
                        />
                        dias
                      </label>
                      <label htmlFor="nochanges">
                        Processos sem mov. relevante nos últimos
                        <InputNumber
                          inputId="nochanges"
                          name="nochanges"
                          placeholder="X"
                          value={noChangesDay}
                          onValueChange={(e) => setNoChangesDay(Number(e.value))}
                          min={0}
                        />
                        dias
                      </label>
                    </div>
                  </Section>
                </div>
              </div>

              <footer className="search-actions">
                <div className="buttons">
                  <Button
                    icon="pi pi-undo"
                    iconPos="left"
                    label="Limpar campos"
                    className="p-button-outlined p-button-secondary"
                    type="button"
                    onClick={() => handleClear(handleReset)}
                  />
                  <Button
                    icon="pi pi-check"
                    iconPos="left"
                    label="Pesquisar processos"
                    type="submit"
                    disabled={isSubmitting}
                  />
                </div>
              </footer>
            </form>
          )}
        </Formik>
      </div>
    </FilterStyles>
  );
};

export default SearchLawsuitSummary;
